import React from "react";
import "./style.scss";
import { connect } from "react-redux";

import Stomp from "stompjs";
import Logo from "../../assets/logo.png";
import { USER } from "../../constants/app";
import Input from "../../components/controls/Input";
import ImagePreview from "../../containers/modalPreviewImage";
import "react-lazy-load-image-component/src/effects/blur.css";
import { LazyLoadImage } from "react-lazy-load-image-component";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { baseUrl, wsUrl } from "../../auth/secret";
import { isEmptyOrWhiteSpace, calcDiffDate } from "../../helpers";
import { faPaperPlane } from "@fortawesome/free-regular-svg-icons";
import { faPaperclip, faAngleLeft } from "@fortawesome/free-solid-svg-icons";
import { fetch_message_list, fetch_more_message, fetch_conversation, update_chat, update_media_layout } from "../../redux/Conversations/actions";
import PreviewImage from "../../containers/modalPreview";
import { useCachedThumbnails } from "../../helpers/storeIndexDB";

const sw = new WebSocket(wsUrl);

class index extends React.Component {
  state = {
    message: "",
    image: "",
    previewImage: "",
    ImagePreview: "",

    shouldMessageRender: false,

    pageState: 1,
    isOpen: false,
    hasMore: false,
    swClient: Stomp.over(sw),
    KeyPreviewImage: 0,
  };

  componentWillMount() {
    this.state.swClient.connect({ login: "guest", passcode: "guest" }, (con) => {
      this.state.swClient.subscribe("/user/queue/reply", (data) => {
        let parseData = JSON.parse(data.body);
        this.props.fetch_conversation({ page: 1, rowsPerPage: 1000 });
        if (parseData.type !== "JOIN" && parseData.type !== "LEAVE") {
          if (this.props.recipient !== "" && this.props.recipient === parseData.sender) {
            let message = {
              id: parseData.id,
              sender: parseData.sender,
              contentType: parseData.contentType,
              content: parseData.content,
              timestamp: parseData.timestamp,
            };
            this.props.update_chat({ message });
            setTimeout(() => this.scrollToBottom(), 100);
          }

          if (parseData.sender !== USER && this.props.recipient !== parseData.sender) {
            new Notification(parseData.sender, {
              body: parseData.contentType === "TEXT" ? parseData.content : "Sent an image.",
              icon: Logo,
            });
          }
        }
      });
    });
  }

  componentDidMount() {
    this.scrollToBottom();
    this.setState({ hasMore: true });
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.recipient !== nextProps.recipient) {
      this.setState({ pageState: 1, shouldMessageRender: false }, () => {
        this.props.fetch_message_list({ page: { page: this.state.pageState, rowsPerPage: 50 }, recipient: nextProps.recipient }, () => {
          this.setState({ shouldMessageRender: true });
          setTimeout(() => this.scrollToBottom(), 200);
        });
      });
    }
  }

  _handleOnChangeFile = (e) => {
    e.preventDefault();
    if (e.target.files && e.target.files[0]) {
      let reader = new FileReader();
      reader.readAsDataURL(e.target.files[0]);
      this.setState({
        image: e.target.files[0],
        previewImage: URL.createObjectURL(e.target.files[0]),
        isOpen: true,
      });
    }
  };

  _handleOnChange = (e) => {
    this.setState({ [e.target.name]: e.target.value });
  };

  _handleKeyPress = (e) => {
    if (e.which === 13) {
      this._handleSendMessage();
    }
  };

  _handleSendMessage = () => {
    if (isEmptyOrWhiteSpace(this.state.message)) {
      let message = {
        type: "CHAT",
        sender: USER,
        contentType: "TEXT",
        content: this.state.message,
        timestamp: new Date().getTime(),
      };
      this.state.swClient.send(`/app/user/${this.props.recipient}`, { login: "guest", passcode: "guest" }, JSON.stringify(message));
      this.props.update_chat({ message });
      this.setState({ message: "" }, () => {
        this.scrollToBottom();
      });
    }
  };

  _handleSendImageMessage = () => {
    let image = new FormData();
    image.append("file", this.state.image);
    fetch(`${baseUrl}/public/upload-file`, {
      method: "POST",
      headers: {
        Accept: "*/*",
      },
      body: image,
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.header.result === true) {
          this._handleTogglePreviewImage();
          this.setState({ sendName: "Send" });
          var message = {
            type: "CHAT",
            content: data.body,
            contentType: "IMAGE",
            sender: USER,
            timestamp: new Date().getTime(),
          };
          this.state.swClient.send(`/app/user/${this.props.recipient}`, { login: "guest", passcode: "guest" }, JSON.stringify(message));
          this.props.update_chat({ message });
          this.setState({ message: "" }, () => {
            this.scrollToBottom();
          });
        }
      });
  };

  _handleLoadMore = () => {
    this.setState({ pageState: this.state.pageState + 1 }, () => {
      this.props.fetch_more_message({ page: { page: this.state.pageState, rowsPerPage: 50 }, recipient: this.props.recipient });
      this.setState({ hasMore: true });
    });
  };

  _handleScroll = (e) => {
    if (e.target.scrollTop <= 0) {
      if (this.state.hasMore) {
        this._handleLoadMore();
      }
      this.setState({ hasMore: false });
    }
  };

  _handleBack = () => {
    this.props.update_media_layout();
  };

  scrollToBottom = () => {
    this.messagesEnd.scrollIntoView({ behavior: "smooth" });
  };

  _handleTogglePreviewImage = () => {
    this.setState({ isOpen: !this.state.isOpen });
  };

  _handlePreviewImage = (message) => {
    this.setState({ ImagePreview: message.content, isOpenPreview: true });
  };

  _handleClosePreviewImage = () => {
    this.setState({ isOpenPreview: false });
  };

  render() {
    return (
      <React.Fragment>
        {!this.props.shouldMediaRender ? (
          <div style={{ width: "calc(100vw - 325px)" }}>
            <ImagePreview previewImage={this.state.previewImage} isOpen={this.state.isOpen} onToggle={this._handleTogglePreviewImage} onSend={this._handleSendImageMessage} />
            <PreviewImage key={this.state.ImagePreview.timestamp} image={this.state.ImagePreview} isOpen={this.state.isOpenPreview} onToggle={this._handleClosePreviewImage} timestamp={this.state.ImagePreview.timestamp} />
            <div onScrollCapture={(e) => this._handleScroll(e)} className="ut-message-list">
              {this.state.shouldMessageRender ? (
                this.props.messages.map((message, i) => {
                  return <Message key={message.timestamp} onClick={() => this._handlePreviewImage(message)} message={message} />;
                })
              ) : this.props.recipient !== "" ? (
                <div className="ut-all-center" style={{ height: "100vh" }}>
                  <span>Loading Conversation...</span>
                </div>
              ) : (
                <div className="ut-all-center" style={{ height: "100vh" }}>
                  <span>No Conversation selected!</span>
                </div>
              )}
              <div
                ref={(el) => {
                  this.messagesEnd = el;
                }}
              />
            </div>
            {this.props.recipient ? (
              <div className="ut-message-input-area">
                <input ref={(file) => (this.fileImage = file)} onChange={this._handleOnChangeFile} type="file" accept="image/jpg, image/jpeg, image/png" name="image" id="image" hidden />
                <Input name="message" value={this.state.message} onChange={this._handleOnChange} onKeyPress={this._handleKeyPress} size="sm" inputStyle="pilled" placeholder="message" />
                <FontAwesomeIcon className="ut-message-button" size="lg" icon={faPaperclip} onClick={() => this.fileImage.click()} />
                <FontAwesomeIcon className="ut-message-button" size="lg" icon={faPaperPlane} onClick={this._handleSendMessage} />
              </div>
            ) : (
              ""
            )}
          </div>
        ) : (
          <div style={{ width: "calc(100vw - 325px)" }}>
            <div className="ut-media-header">
              <div className="ut-media-back" onClick={this._handleBack}>
                <FontAwesomeIcon className="ut-color-primary" icon={faAngleLeft} size="lg" />
                <span className="ut-color-primary">Back</span>
              </div>
              <span>Shared Photos</span>
            </div>
            <div className="ut-media-content">
              <span>photo will show here</span>
            </div>
          </div>
        )}
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state) => ({
  shouldMediaRender: state.Conversation.shouldMediaRender,
  sharedPhotos: state.Conversation.sharedPhotos,
  recipient: state.Conversation.recipient,
  messages: state.Conversation.messages,
});

export default connect(mapStateToProps, { fetch_message_list, fetch_more_message, fetch_conversation, update_chat, update_media_layout })(index);

function Message(props) {
  const { content, contentType, sender, timestamp } = props.message;
  const cachedThumbnails = content && content.startsWith("/upload/") ? useCachedThumbnails(content) : null; //eslint-disable-line
  return (
    <div className={sender === USER ? "ut-message-sender" : "ut-message-reciever"}>
      {contentType === "TEXT" ? <span className="ut-message-content">{content}</span> : <LazyLoadImage onClick={props.onClick} alt={timestamp} effect="blur" className="ut-message-image" src={cachedThumbnails || `${baseUrl}${content}`} />}
      <span className="ut-message-timestamp ut-info">
        <i>{calcDiffDate(timestamp)}</i>
      </span>
    </div>
  );
}
